import { usePaymentMethod } from '@payments-checkout/shared/providers';
import { Spinner } from '@stone-payments/jade';
import { DigitalWalletSelectionOption } from '../../app/components/digitalWallets/digitalWalletSelection.component';
import { digitalWallets } from '../../app/types/digitalWallets.types';
import { useApplePayAvailability } from '../hooks/useApplePayAvailability';
import { ApplePayLogoIllustration } from './applePayLogo.component';

type ApplePayProps = {
  setIsDigitalWalletsSelected: (digitalWallet: digitalWallets) => void;
  active?: boolean;
};

export const ApplePay = ({
  setIsDigitalWalletsSelected,
  active,
}: ApplePayProps) => {
  const { isCustomerFormLoading } = usePaymentMethod();
  const { isApplePayAvailable, isApplePayLoading } = useApplePayAvailability();

  if (isApplePayLoading) return <Spinner size="medium" color="brand" />;
  if (!isApplePayAvailable) return null;

  return (
    <DigitalWalletSelectionOption
      onClick={() => setIsDigitalWalletsSelected('applePay')}
      active={active}
      disabled={isCustomerFormLoading}
    >
      <ApplePayLogoIllustration />
    </DigitalWalletSelectionOption>
  );
};
